import {Button, Space} from "antd";
import {GetStoreServiceApiResponse} from "../../../../react-query-hooks/store/services/get-store-service/types";
import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {
  handleFacebookLink,
  handleMailLink,
  handleStoreServiceLink,
  handleTwitterLink,
} from "../../../../utils/products";
import {REBRAND_BASE_URL} from "../../../../services/config";
import {ProfileWidgetSkeleton} from "../../../calls/upcoming-calls/profile-widget/profile-widget-skeleton";
import {StyledShareServiceWidgetWrapper} from "../../../calls/service/share-service-widget/share-service-widget.style";
import {ShareOfferingWidget} from "../../../public-profile/offering/share-offering";

const ShareStoreServiceWidget = ({
  storeServiceData,
  isFetching,
}: {
  isFetching: boolean;
  storeServiceData: GetStoreServiceApiResponse;
}) => {
  const {state: profileState} = useGetProfileContext();

  const extraParams = {
    facebookLink: handleFacebookLink({
      username: profileState.profileData.username,
    }),
    twitterLink: handleTwitterLink({
      textContent: `I just created a service titled ${storeServiceData.productService.name} on Coachli!`,
      username: profileState.profileData.username,
    }),
    mailLink: handleMailLink({
      body: `I just created a product titled ${storeServiceData.productService.name} on Coachli! ${REBRAND_BASE_URL}/${profileState.profileData.username}`,
      subject: "",
    }),
    copyLink: handleStoreServiceLink({
      serviceId: storeServiceData.productService.id,
      slug: storeServiceData.productService.slug,
      username: profileState.profileData.username,
      tinyUrl: storeServiceData.productService.tiny_url,
      windowNav: true,
    }),
  };
  let stripedHtml = storeServiceData.productService.description.replace(/<[^>]+>/g, "");
  const productDescription = stripedHtml;

  return (
    <StyledShareServiceWidgetWrapper>
      {isFetching ? (
        <ProfileWidgetSkeleton />
      ) : (
        <>
          <h2 className="profile-widget-heading">Share service link</h2>
          <div className="profile-widget-card">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <div className="profile-widget-card-header">
                <h3 className="profile-widget-card-user-name">
                  {storeServiceData.productService.name}
                </h3>
              </div>
              <p className="profile-widget-card-bio">{productDescription}</p>
              <>
                <div>
                  <Button
                    size="small"
                    block
                    htmlType="button"
                    target="_blank"
                    href={handleStoreServiceLink({
                      serviceId: storeServiceData.productService.id,
                      slug: storeServiceData.productService.slug,
                      username: profileState.profileData.username,
                      tinyUrl: storeServiceData.productService.tiny_url,
                      windowNav: true,
                    })}
                  >
                    View service page
                  </Button>
                </div>
                <ShareOfferingWidget
                  title="Share service via"
                  extraParams={extraParams}
                />
              </>
            </Space>
          </div>
        </>
      )}
    </StyledShareServiceWidgetWrapper>
  );
};

export {ShareStoreServiceWidget};
